import { createSlice } from '@reduxjs/toolkit'

import { customerApi } from '../services/customer'

const initialState = {
    customerId: null,
    customerBillingAddress: null,
    customerDeliveryAddress: null,
    customerShippingOption: null,
    customerRequiredShippingDate: null,
}

export const customerSlice = createSlice({
    name: 'customersSlice',
    initialState,
    reducers: {
        setCustomerId: (state, action) => {
            state.customerId = action.payload
        },

        unsetCustomerId: (state) => {
            state.customerId = null
        },

        setCustomerBillingAddress: (state, action) => {
            state.customerBillingAddress = action.payload
        },

        setCustomerDeliveryAddress: (state, action) => {
            state.customerDeliveryAddress = action.payload
        },

        setCustomerShippingOption: (state, action) => {
            state.customerShippingOption = action.payload
        },

        setCustomerRequiredShippingDate: (state, action) => {
            state.customerRequiredShippingDate = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addMatcher(customerApi.endpoints.getCustomer.matchFulfilled, (state, { payload }) => {
            state.customerId = payload.customerId
        })
    },
})

export const selectCustomerId = (state) => state.customerSlice.customerId
export const selectCustomerBillingAddress = (state) => state.customerSlice.customerBillingAddress
export const selectCustomerDeliveryAddress = (state) => state.customerSlice.customerDeliveryAddress
export const selectCustomerShippingOption = (state) => state.customerSlice.customerShippingOption
export const selectCustomerRequiredShippingDate = (state) => state.customerSlice.customerRequiredShippingDate

export const {
    setCustomerBillingAddress,
    setCustomerDeliveryAddress,
    setCustomerId,
    setCustomerRequiredShippingDate,
    setCustomerShippingOption,
    unsetCustomerId,
} = customerSlice.actions

export default customerSlice.reducer
